import ScheduleInterface, { ScheduleGetUser } from "@/interfaces/Schedule.interface";
import api from "../config";

export class ScheduleRest {
    getSchedule(params: any): Promise<any> {
        return api.get('/schedule', { params }).then((response) => response.data);
    }

    getScheduleById(id: any): Promise<any> {
        return api.get(`/schedule/${id}`).then((response) => response.data);
    }

    getScheduleUserById(id: any): Promise<any> {
        return api.get(`/schedule/${id}/user`).then((response) => response.data);
    }

    getScheduleByUser(): Promise<ScheduleGetUser[]> {
        return api.get('/schedule/user').then((response) => response.data);
    }

    createSchedule(data: any): Promise<any> {
        return api.post('/schedule', data).then((response) => response.data);
    }

    updateSchedule(id: any, data: ScheduleInterface): Promise<any> {
        return api.put(`/schedule/${id}`, data).then((response) => response.data);
    }
    
    deleteSchedule(id: any): Promise<ScheduleInterface> {
        return api.delete(`/schedule/${id}`).then((response) => response.data);
    }
}